<h2>SA KA</h2>
<div class="example-container">
   
    <div class="example-container">
        <mat-form-field>
          <mat-label>Enter your password</mat-label>
          <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" [(ngModel)]="myPassword" (input)="onPasswordInput()">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      
        <!--h5>{{myPassword}}</h5-->
      </div>
<div *ngIf="hidecode">
<table mat-table class="lessons-table mat-elevation-z8" [dataSource]="KassenP">
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef>Edit</th>
        <td mat-cell class="content" *matCellDef="let lesson">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(lesson) : null"
                          [checked]="selection.isSelected(lesson)"
                          [aria-label]="checkboxLabel(lesson)"
                          [disabled]="!edited">
            </mat-checkbox>
          </td>
        <td mat-footer-cell *matFooterCellDef>Edit</td> 
    </ng-container>
    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>id</th>
        <td mat-cell *matCellDef="let lesson">{{lesson.id}}
            
    <div class="button">
        <button mat-raised-button (click)="editButton()" aria-selected="edited" ><mat-icon>edit</mat-icon>Edit</button>
        <!-- <a class="icon" [routerLink]="" (click)="goPalletInfo(1)"><mat-icon>information</mat-icon></a> -->
    </div>
        </td>
        <td mat-footer-cell *matFooterCellDef>id</td> 
    </ng-container>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>name</th>
        <td mat-cell *matCellDef="let lesson"><input matInput class="input" type="text" [disabled]="!selection.isSelected(row)" [(ngModel)]="lesson.name"></td>

        <!--td *matCellDef="let lesson">{{lesson.name}}</td-->
        <td mat-footer-cell *matFooterCellDef>Summe</td> 
    </ng-container>
    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>date</th>
        <td *matCellDef="let lesson">{{lesson.date}}</td>
        <td mat-footer-cell *matFooterCellDef></td> 
    </ng-container>
    <ng-container matColumnDef="einnahmen">
        <th mat-header-cell *matHeaderCellDef>einnahmen</th>
        <td *matCellDef="let lesson"><font color=green>{{lesson.einnahmen}}</font></td>
        <td mat-footer-cell *matFooterCellDef><font color=green>{{einahmen_sum | number : '1.0-2'}}</font> </td> 
    </ng-container>

    <ng-container matColumnDef="ausgaben">
        <th mat-header-cell *matHeaderCellDef>ausgaben</th>
        <td *matCellDef="let lesson"><font color=red>{{lesson.ausgaben}}</font></td>
        <td mat-footer-cell *matFooterCellDef><font color=red>{{ausgaben_sum | number : '1.0-2'}} </font></td> 
    </ng-container>
    <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef>bemerkung</th>
        <td *matCellDef="let lesson">{{lesson.note}}</td>
        <td mat-footer-cell *matFooterCellDef>Bilanz: {{bilanz | number : '1.0-2'}} </td> 
    </ng-container>


    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns" class="footer-row"></tr>
</table>


<div>EinnahmenSumme: {{einahmen_sum  | number : '1.0-2'}}</div>
<div>AusgabenSumme: {{ausgaben_sum  | number : '1.0-2'}}</div>
<div>Kontostand: {{bilanz | number : '1.0-2'}}</div>

<iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&bgLayer=atkis&catalogNodes=11&layers=luftbild_parz&E=619323.64&N=5269952.98&zoom=12.170018322294407' width='600' height='450' frameborder='0' style='border:0'></iframe>

</div>